module.exports = __webpack_public_path__ + "media/AUDIO-10.ab8d1052.mp3";